export default __webpack_public_path__ + "static/media/4.ce4aa9e7.jpg";